import { Component, ElementRef, OnInit, ViewChildren, QueryList } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import moment from 'moment';
import { Moment } from 'moment';
import { element, promise } from 'protractor';
import { async } from 'rxjs/internal/scheduler/async';
import { DiscountReasonInfo, PageBase } from 't4core';
import { forEachChild } from 'typescript';
import { CampaignInfo, CampaignType, DiscountModel, DiscountValueType, GenerateVoucherResult, RentalInfo, UIService } from '../../../../../projects/t4core/src/public-api';
import { T4BookingLink } from '../../../../t4common';
import { FormControl, Validators } from '@angular/forms';
import { Input } from '@angular/core';
import { Injectable, TemplateRef } from '@angular/core';
import { T4TranslationEditorComponent } from '../../../../t4common/components/t4-translation-editor/t4-translation-editor.component';


@Component({
  styleUrls: ['./campaign.component.css'],
  selector: 't4-campaign-details',
  templateUrl: './campaign.component.html',
})

export class CampaignComponent extends PageBase implements OnInit {

  private _fromDate: Moment = moment().startOf('month');
  private _toDate: Moment = moment().endOf('month');
   //  toastService: any;

  public get fromDate(): Moment { return this._fromDate; }
  public set fromDate(value: Moment) { this._fromDate = value; }
  public get toDate(): Moment { return this._toDate; }
  public set toDate(value: Moment) { this._toDate = value; }

  // Data model
  @Input() public CampagneID: string;
  @Input() public isDialog: boolean = false;
  @ViewChildren(T4TranslationEditorComponent) translationEditors: QueryList<T4TranslationEditorComponent>;

  inputValidFrom = new FormControl('', [Validators.required, Validators.minLength(1)]);
  inputValidThrough = new FormControl('', [Validators.required, Validators.minLength(1)]);

  amountValue = new FormControl('', [Validators.required, Validators.min(0), Validators.pattern(/^(0|[1-9]\d*)?$/)]);
  procentValue = new FormControl('', [Validators.required, Validators.min(0), Validators.max(100), Validators.pattern(/^(0|[1-9]\d*)?$/)]);
  timeValue = new FormControl('', [Validators.required, Validators.min(0), Validators.pattern(/^(0|[1-9]\d*)?$/)]);
  inputMaxUse = new FormControl('', [Validators.required, Validators.min(0)]);

  priority = new FormControl('', [Validators.required, Validators.min(0)]);

  inputMonths = new FormControl('', [Validators.required, Validators.pattern("^[1-9]*$")]);

  public TemplateCode: string;
  public campaign: CampaignInfo
  public BookLink: T4BookingLink [];
  public selectedReason: string; 
  public Reasons: any = [];
  public TemplateList: any = [];
  public GetUsedSubCampaigns: any = [];
  public voucherToken: any = [];
  public currentContext: string;
  public ValidMonths: number;


  public timeType: DiscountValueType = DiscountValueType.Time;

  public constructor(el: ElementRef, private route: ActivatedRoute, private router: Router) {
    super(el, "Campaign");

  }

  async ngOnInit() {

    this.route.params.subscribe(params => {
      if (params.CampaignID && params.CampaignID != "") this.CampagneID = params.CampaignID;
      if (params.TemplateCode && params.TemplateCode != "") this.TemplateCode = params.TemplateCode;
    })

    await this.loadCampaignInfo();

    if (!this.campaign.CanEdit) {
       this.inputValidFrom.disable();
       this.inputValidThrough.disable();
       this.amountValue.disable();
       this.procentValue.disable();
       this.inputMaxUse.disable();
       this.priority.disable();
    }

    await this.loadReasons();
    await this.loadTemplates();

    //     this.campaign.Value = this.campaign.ValueType == DiscountValueType.Time ? this.campaign.Value = 60 / 60 : this.campaign.Value;

    this.selectedReason = this.Reasons.find(x => x.Id == this.campaign.ReasonId)?.Reason;
  }

  public subForms = {
    loading: "hidden",
  };

  public loading: any = {
    Campaign: false,
    UsedSubCampaigns: false,
    Reasons: false,
    Templates: false,
  };

  private async loadCampaignInfo(): Promise<Boolean> {
    this.loading.Campaign = true;
    this.campaign = await this.Api.get<CampaignInfo>("/Campaign/GetCampaignInfo?campaignID=" + this.CampagneID);

    var duration = moment.duration(this.campaign.ValidThrough.diff(this.campaign.ValidFrom));
    this.ValidMonths = duration.asMonths();

    this.ValidMonths = Math.round(this.ValidMonths);

      if(this.campaign.ValueType == DiscountValueType.Time) this.campaign.Value = this.campaign.Value / 60 / 60;
    this.loading.Campaign = false;

    return true;
  }

  private async loadReasons(): Promise<Boolean> {
    this.loading.Reasons = true;
    this.Reasons = await this.Api.get<DiscountReasonInfo>("/Campaign/GetDiscountReasons"); 
    this.loading.Reasons = false;

    return true;
  }

  private async loadTemplates(): Promise<Boolean> {

    var token = this.UI.beginLoading("T4.Campaigns.campaign.msgsubcampaigns", "Loading used Campaigns", null);
    this.TemplateList = await this.Api.get<CampaignInfo>("/Campaign/GetSubCampaigns", { parentCode: this.CampagneID });
    this.UI.loaderCompleted(token);

    return true;
  }

  public async UpdateCampaign(): Promise<Boolean> {
    if (this.campaign.ValueType == DiscountValueType.Time) this.campaign.Value = this.campaign.Value * 60 * 60;

    this.campaign.ValidThrough = !this.campaign.IsTemplate ? this.campaign.ValidThrough : this.campaign.ValidFrom.clone().add(this.ValidMonths, 'month');   // this.campaign.ValidThrough

    //Save the translation keys to the campaign.
    this.campaign.Title = `T4.Campaign.${this.campaign.DiscountCode}.Title`;
    this.campaign.AppMessageTitle = `T4.Campaign.${this.campaign.DiscountCode}.AppMessageTitle`;
    this.campaign.AppMessageDescription = `T4.Campaign.${this.campaign.DiscountCode}.AppMessageDescription`;
    this.campaign.AppMenuMessageTitle = `T4.Campaign.${this.campaign.DiscountCode}.AppMenuMessageTitle`;
    this.campaign.AppMenuMessageDescription = `T4.Campaign.${this.campaign.DiscountCode}.AppMenuMessageDescription`;
    this.campaign.MessageContentHeader = `T4.Campaign.${this.campaign.DiscountCode}.MessageContentHeader`;
    this.campaign.MessageContent = `T4.Campaign.${this.campaign.DiscountCode}.MessageContent`;
    this.campaign.CampaignTerms = `T4.Campaign.${this.campaign.DiscountCode}.CampaignTerms`;

    await this.Api.post<CampaignInfo>("/Campaign/UpdateCampaign", this.campaign );
    //Save the translation editors.
    await this.translationEditors.forEach(tb => tb.saveTranslations());
    this.UI.snackBarLocal('T4.Campaigns.CampaignDetails.msgSettingsUpdated', 'Settings has been updated!')
    
    if (this.campaign.ValueType == DiscountValueType.Time) this.campaign.Value = this.campaign.Value / 60 / 60;
    return true;
  }


  public async generateVouchers(): Promise<Boolean> {

    this.UI.loaderCompleted(this.voucherToken);

    await this.UI.openDialog("T4.Campaigns.CreateVouchersDialog", {
      width: "800px",
      height: "425px",
      data: this.campaign
    });
    
    return true;
  }

  public async showCamp(campaign: CampaignInfo) {
    await this.UI.openDialog("T4.Campaigns.CreateVouthersDialog", {
      width: "600px",
      height: "1000px",
      data: campaign.DiscountCode
    });
  }
}
